import script from "./statistics.vue?vue&type=script&setup=true&lang=ts"
export * from "./statistics.vue?vue&type=script&setup=true&lang=ts"

import "./statistics.vue?vue&type=style&index=0&id=468882f4&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-468882f4"]])

export default __exports__